<template>
  <div class="help-page">
    <Tree></Tree>
    <div class="edit" v-loading="loading">
      <div class="toolbar-box" v-if="Object.keys(dataset).length > 0">
        <Toolbar
          :editor="editor"
          :defaultConfig="toolbarConfig"
        />
        <div class="switch-box">
          <span class="text">目录</span>
          <el-switch v-model="showToc">
          </el-switch>
        </div>
      </div>
      <div class="edit-box" v-if="Object.keys(dataset).length > 0">
        <History :dataset="dataset" @reviews="historyReviews" @edit="historyEdit"></History>
        <div class="content">
          <div class="editor">
            <div class="editor-detail">
              <div class="title">
                <input type="text" v-model="title" placeholder="标题" :disabled="dataset.release_status === 2">
              </div>
              <Editor
                class="d"
                :defaultConfig="editorConfig"
                v-model="html"
                @onChange="onChange"
                @onCreated="onCreated"
              />
            </div>
          </div>
          <Catalog :toc="toc" v-if="showToc" @select="selectCatalog"></Catalog>
        </div>
        <Btns :dataset="dataset" v-if="!loading" @reviews="showReviews" @save="save" @send="send" @cancelSend="cancelSend" :isDisabled="isDisabled"></Btns>
      </div>
    </div>
    <ViewDialog v-model="showViewDialog" :html="reviewsHtml"></ViewDialog>
    <ViewsPage v-model="showViewDialogPage" :id="Number(dataset.id)" :html="reviewPageHtml"></ViewsPage>
    <div class="null-tip" v-if="Object.keys(dataset).length === 0 && !loading">请选择或添加文档</div>
  </div>
</template>
<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { SlateNode, DomEditor } from '@wangeditor/editor'
import Catalog from '../components/catalog'
import ViewDialog from './viewsDialog'
import ViewsPage from './viewsPage'
import Tree from './tree'
import History from './history'
import Btns from './btns'

import uploadApi from "@/services/api/upload/upload";
import axios from "axios";
import api from '@/services/api/help/help'

import bus from '@/bus'

axios.defaults.withCredentials = false;
axios.defaults.crossDomain = true;
let instance = axios.create({});
export default {
  name: "MyEditor",
  components: { Editor, Toolbar, Catalog, ViewDialog, Tree, History, Btns, ViewsPage},
  data() {
    const _ts = this
    return {
      toolbarConfig: {
        excludeKeys: [
          "blockquote",
          "todo",
          "insertTable",
          "undo",
          "redo",
          "fullScreen",
          "codeBlock"
        ]
      },
      editorConfig: {
        placeholder: "请输入内容...",
        scroll: false,
        readOnly: false,
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            server: "/api/upload", //上传地址
            maxFileSize: 500 * 1024 * 1024, //图片大小限制 (500M)

            // 自定义上传
            async customUpload(file, insertFn) {
              // file 即选中的文件
              _ts.isFileTypeFn([file]);
              if (_ts.fileTypeLock) {
                _ts.$message.error("上传图格式不支持!");
                return;
              }
              _ts.tis = _ts.$message({
                showClose: true,
                duration: 0,
                message: "图片上传中...",
                type: "warning",
              });

              for (let item of [file]) {
                await _ts.uploadNow(item, 'urlList');
              }
              // // 自己实现上传，并得到图片 url alt href
              // // 最后插入图片
              setTimeout(() => {
                for (let i = 0, len = _ts.urlList.length; i < len; i++) {
                  let { url, alt, href } = _ts.urlList[i]
                  insertFn(url, alt, href);
                }
                _ts.tis.close();
              }, 0);
            },
          },
          insertImage: {
            onInsertedImage(imageNode) {
              // 插入图片回调
              _ts.urlList = [];
            },
          },
          uploadVideo: {
            server: "/api/upload", //上传地址
            maxFileSize: 500 * 1024 * 1024, //大小限制 (500M)

            // 自定义上传
            async customUpload(file, insertFn) {
              // file 即选中的文件
              // _ts.isFileTypeFn([file]);
              // if (_ts.fileTypeLock) {
              //   _ts.$message.error("上传附件格式不对!");
              //   return;
              // }
              _ts.tis = _ts.$message({
                showClose: true,
                duration: 0,
                message: "视频上传中...",
                type: "warning",
              });

              for (let item of [file]) {
                await _ts.uploadNow(item, 'videoUrlList');
              }
              // // 自己实现上传，并得到图片 url alt href
              // // 最后插入图片
              setTimeout(() => {
                for (let i = 0, len = _ts.videoUrlList.length; i < len; i++) {
                  let { url } = _ts.videoUrlList[i]
                  insertFn(url);
                }
                _ts.tis.close();
              }, 0);
            },
          },
          insertVideo: {
            onInsertedVideo(imageNode) {
              // 插入图片回调
              _ts.videoUrlList = [];
            },
          },
        },
        EXTEND_CONF: {
          mentionConfig: {
            // showModal: this.showMentionModal,
            // hideModal: this.hideMentionModal,
          },
        }
      },
      editor: null,
      html: "",
      toc: [], // 目录结构
      showViewDialog: false,
      showToc: true,
      // 上传
      fileType: ["jpg", "jpeg", "png", "bmp", "gif", "svg"],
      fileTypeLock: false,
      urlList: [],
      videoUrlList: [],
      title: '',
      dataset: {},
      reviewsHtml: '',
      loading: false,
      showViewDialogPage: false,
      reviewPageHtml: ''
    }
  },
  computed: {
    isDisabled() {
      return !this.title || !this.html || this.editor?.isEmpty()
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = "<p>Ajax 异步设置内容 HTML</p>";
    // }, 1500);
  },
  created() {
    bus.$on('treeSelectElement', res => {
      this.title = res.title
      this.getEditDetai(res.id)
    })
    bus.$on('delDocument', res => {
      if(Number(this.dataset.id) === Number(res.id)) {
        this.dataset = {}
      }
    })
  },
  methods: {
    async getEditDetai(id) {
      this.loading = true
      this.dataset = {}
      this.editor = null
      await this.$nextTick(() => {})
      let result = await api.documentRed({id})
      this.html = result.document_content
      this.dataset = result
      this.loading = false
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
      this.dataset.release_status === 2 ? this.editor.disable() : this.editor.enable()
    },
    onChange() {
      this.getToc()
    },
    getToc() {
      this.toc = this.editor.getElemsByTypePrefix('header').map(header => {
        const text = SlateNode.string(header)
        const { id, type } = header
        // const toolbar = DomEditor.getToolbar(this.editor)
        // console.log('-------d---------', toolbar.getConfig().toolbarKeys)
        let ele = document.getElementById(id)
        let offsetTop = ele.offsetTop
        return {
          id,
          text,
          type,
          offsetTop,
          ele
        }
      })
    },
    showReviews() {
      this.reviewPageHtml = this.html
      this.showViewDialogPage = true
    },
    isFileTypeFn(fileList) {
      const _ts = this;
      _ts.fileTypeLock = false;
      for (let i = 0, len = fileList.length; i < len; i++) {
        const _type = fileList[i].name.slice(fileList[i].name.lastIndexOf(".") + 1);
        if (_ts.fileType.indexOf(_type.toLowerCase()) < 0) {
          _ts.fileTypeLock = true;
          break;
        }
      }
    },
    async uploadNow(file, arr) {
      let _this = this;
      try {
        const _data = {
          attachment_name: file.name,
        };
        let imgResult = null
        if(arr === 'urlList') {
          imgResult = await this.fileAwait(file.raw || file)
        }
        const res = await uploadApi.getDocumentEditorAttachmentUploadPolicy(_data);
        if (res) {
          let dataset = new FormData();
          dataset.append("x-oss-object-acl", `public-read`);
          dataset.append("name", res.oss_attachment_name);
          dataset.append("key", res.dir + res.oss_attachment_name);
          dataset.append("policy", res.policy);
          dataset.append("OSSAccessKeyId", res.accessid);
          dataset.append("success_action_status", "200");
          dataset.append("callback", res.callback);
          dataset.append("Content-Disposition", `attachment; filename="${file.name}"`);
          dataset.append("signature", res.signature);
          dataset.append("file", arr === 'urlList' ? imgResult.Blob : (file.raw || file));
          let httpDefaultOpts = {
            baseURL: "",
            method: "post",
            cache: false,
            url: process.env.NODE_ENV === "development" ? "airworthiness_certified" : res.host,
            timeout: 0,
            data: dataset,
            headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
          };
          let result = await instance(httpDefaultOpts);
          const resStr = result.data.data.document_editor_url;
          _this[arr].push({
            url: resStr,
            alt: file.name,
            href: resStr
          });
        }
      } catch (error) {
        // this.delFilesList()
        console.log(error);
        this.tis.close();
      }
   },
   fileAwait(file) {
    let imgReset = new LDFimg()
    return new Promise((resolve, reject) => {
      imgReset.getFileCompress(file, res => {
        console.log(res)
        resolve(res)
      })
    })
   },
   async historyReviews(item) {
      let result = await api.documentDraftRecordsRead({id: item.id})
      this.reviewsHtml = result.document_content
      this.showViewDialog = true
    },
    async historyEdit(item) {
      this.loading = true
      let result = await api.documentDraftRecordsRead({id: item.id})
      this.html = result.document_content
      this.$nextTick(() => {
        this.loading = false
      })
    },
    async updateDetail() {
      this.loading = true
      let params = {
        id: this.dataset.id,
        title: this.title,
        document_content: this.html
      }
      await api.documentDraftUpdate(params)
      this.loading = false
    },
    async save() {
      await this.updateDetail()
      await this.getEditDetai(this.dataset.id)
      bus.$emit('treeElementUpdate', this.dataset)
      this.$message({
        message: '保存草稿成功',
        type: 'success'
      })
    },
    async send({id, release_status, scheduled_release_time}) {
      await this.updateDetail()
      await api.documentDraftUpdateReleaseStatus({id, release_status, scheduled_release_time})
      await this.getEditDetai(this.dataset.id)
      bus.$emit('treeElementUpdate', this.dataset)
    },
    async cancelSend() {
      await this.updateDetail()
      await this.getEditDetai(this.dataset.id)
      bus.$emit('treeElementUpdate', this.dataset)
    },
    selectCatalog(idx) {
      this.toc[idx].ele.scrollIntoView({ behavior: 'smooth' })
    }
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  },
};
</script>
<style lang="scss">
.help-page {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  .null-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 26px;
    color: #ccc;
  }
  .edit {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    .toolbar-box {
      flex-shrink: 0;
      border-bottom: 1px solid rgba(32,32,32,0.08);
      display: flex;
      align-items: center;
      padding: 8px 0;
    }
    .edit-box {
      height: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      .content {
        display: flex;
        justify-content: flex-end;
        height: 0;
        flex: 1;
      }
      .w-e-image-dragger {
        display: block;
      }
      .editor {
        width: 0;
        flex: 1;
        display: flex;
        justify-content: center;
        overflow-x: hidden;
        overflow: overlay;
      }
      .editor-detail {
        width: 960px;
        display: flex;
        flex-direction: column;
        .title {
          flex-shrink: 0;
          height: 56px;
          border-bottom: 1px dashed rgba(32,32,32,0.08);
          font-size: 26px;
          margin-bottom: 18px;
          padding-left: 8px;
          input {
            height: 100%;
            width: 100%;
            border: 0 none;
            &::placeholder {
              font-size: 26px !important;
            }
            &:disabled {
              background-color: initial;
            }
          }
        }
        .d {
          min-height: calc(100% - 76px);
        }
        a {
          text-decoration: underline !important;
          cursor: pointer;
        }
        &.readOnly-edit {
          pointer-events: none;
        }
      }
      .w-e-scroll {
        h1, h2, h3, h4, h5, h6 {
          font-weight: bold;
        }
        &>div {
          &>* {
            margin: 0;
          }
        }
      }
      .w-e-textarea-video-container {
        max-width: 100%;
        video {
          max-width: 100%;
        }
      }

    }
    .switch-box {
      display: flex;
      align-items: center;
      margin-left: 30px;
      .text {
        margin-right: 16px;
        font-size: 14px;
        flex-shrink: 0;
      }
    }
  }
}

</style>
